import { ApiEndpoints } from '../../constants/appConstants';
import logger from '../../utils/logger';
import httpService from '../httpService';

const LOGOUT_NOTIFICATION_TIMEOUT_MS = 5_000;

export const notifyUserLogout = async (): Promise<void> => {
    try {
        await httpService.post<void>(ApiEndpoints.UserLogout, {}, {
            timeout: LOGOUT_NOTIFICATION_TIMEOUT_MS,
        });
    } catch (error) {
        logger.error('Failed to notify application of user logout', error);
    }
};